module.exports = __webpack_public_path__ + "static/img/join.0b4190c.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BarndGmeng2/join.png
// module id = 1111
// module chunks = 18